module.exports = "/_next/static/images/shipping-9edf11fac955446f6a69ebb8af709b28.svg";